const ColoredText = ({ color, children, cn }) => <div style={{ color }} className={cn}>{children}</div>;

export default ColoredText